export default __webpack_public_path__ + "static/media/element_66.928ee32f.jpg";